/** @flow */
import Highlighter from './Highlighter'

export default Highlighter



// WEBPACK FOOTER //
// ./src/index.js